<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small :title="'گزارش سررسید شده های سازمانی'" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="3">
						</v-col>
						<v-col cols="12" md="6">
							<date-navigator v-if="!hideDateRange" v-model="dateRange" :options="{ rangeMode: true }">
								<div class="text-center">
									<v-btn v-if="!hideDateRange" color="primary" small dark class="mx-1" @click="loadData">
										دریافت اطلاعات
									</v-btn>
								</div>
							</date-navigator>
						</v-col>
						<v-col cols="12" md="3" class="d-flex align-center justify-end">
							<export-excel :items="filteredItems" :headers="headers" :fileName="excelFileName">
							</export-excel>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" v-if="organizations.length">
							<span class="ml-2">فیلتر سازمان:</span>
							<v-btn-toggle v-model="organizationFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
								<v-btn v-for="organization in organizations" :key="organization.id" :value="organization.id" small>
									{{ organization.title }}
									<v-badge color="blue" :content="organization.id === 'همه' ? items.length : items.filter(x => x.organizationId == organization.id).length || '0'" inline>
									</v-badge>
								</v-btn>
							</v-btn-toggle>
						</v-col>
						<v-col cols="12" md="8">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>
											<div @click="manageLoans(row.item)" style="cursor:pointer">
												<div class="info--text"><small>شماره وام: {{ row.item.userLoanCode }}</small></div>
												<div class="grey--text"><small>{{ row.item.loanTitle }}</small></div>
											</div>
										</td>
										<td>
											<div @click="manageLoans(row.item)" style="cursor:pointer">
												<div><small>{{ row.item.memberFullName }}</small></div>
												<div class="grey--text"><small>کد ملی: {{ row.item.memberNationalCode }}</small></div>
												<div class="grey--text"><small>موبایل: {{ row.item.memberMobile }}</small></div>
											</div>
										</td>
										<td class="text-center">
											{{ row.item.userLoanAmount.toString().toPriceFormat() }}
											<div class="success--text">
												{{ row.item.userLoanPayableAmount.toString().toPriceFormat() }}
											</div>
										</td>
										<td class="text-center">
											<small>{{ row.item.targetMonth }}</small>
										</td>
										<td class="text-center">
											{{ row.item.installmentAmount.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											<small>{{ convertAssuranceType(row.item.assuranceType) }}</small>
										</td>
										<td class="text-center">
											<small>{{ row.item.organizationName }}</small>
										</td>
										<td class="text-right">
											<div><small>{{ row.item.assurancePersonFullName }}</small></div>
											<div class="grey--text"><small>کد ملی: {{ row.item.assurancePersonNationalCode }}</small></div>
											<div class="grey--text"><small>شماره پرسنلی: {{ row.item.assurancePersonalCode }}</small></div>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" v-if="dialogLoansManager" :data="{ member: selectedMember }" />
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import ManageLoan from '@/views/admin/ManageLoan.vue'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'OrganizationDueDated',
		props: {
			hideDateRange: { type: Boolean, default: false },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-navigator': () => import('@/components/DateNavigator'),
			// 'manage-loan': import('@/views/admin/ManageLoan.vue'),
			ManageLoan,
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				dialogLoansManager: false,
				selectedMember: {},
				errorMessages: '',
				startDate: '',
				startDateValidatioin: '',
				endDateValidatioin: '',
				endDate: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'اطلاعات وام',
						align: 'center',
						sortable: true,
						value: 'userLoanCode',
						width: '170'
					}, {
						text: 'اطلاعات مشتری',
						align: 'start',
						sortable: true,
						value: 'memberFullName',
						width: '150'
					}, {
						text: 'موبایل',
						align: ' d-none',
						sortable: true,
						value: 'memberMobile',
					}, {
						text: 'عنوان وام',
						align: ' d-none',
						sortable: true,
						value: 'loanTitle',
					}, {
						text: 'مبلغ',
						align: 'center',
						sortable: true,
						value: 'userLoanAmount'
					}, {
						text: 'قابل پرداخت',
						align: ' d-none',
						sortable: true,
						value: 'userLoanPayableAmount'
					}, {
						text: 'تاریخ سررسید',
						align: 'center',
						sortable: true,
						value: 'targetMonth',
					}, {
						text: 'مبلغ اقساط',
						align: 'center',
						sortable: true,
						value: 'installmentAmount',
					}, {
						text: 'نوع ضمانت',
						align: 'center',
						sortable: true,
						value: 'assuranceType',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = this.convertAssuranceType(value.assuranceType)
							return text
						}
					}, {
						text: 'سازمان',
						align: 'center',
						sortable: true,
						value: 'organizationName',
					}, {
						text: 'اطلاعات ضامن',
						align: 'center',
						sortable: true,
						value: 'assurancePersonFullName',
						width: '175'
					}, {
						text: 'کد ملی ضامن',
						align: ' d-none',
						sortable: true,
						value: 'assurancePersonNationalCode',
					}, {
						text: 'شماره پرسنلی ضامن',
						align: ' d-none',
						sortable: true,
						value: 'assurancePersonalCode',
					},
				],
				items: [],
				dateRange: { start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toJSON(), end: '' },
				organizations: [],
				organizationFilter: 'همه',
			}
		},
		computed: {
			excelFileName() {
				let name = 'گزارش سررسید های سازمانی'
				if (this.startDate)
					name += ' از ' + this.startDate.toString().split('T')[0]
				if (this.endDate)
					name += ' تا ' + this.endDate.toString().split('T')[0]
				name += '.xls'
				return name
			},
			filteredItems() {
				if (!this.organizationFilter)
					return this.items

				let clonedItems = []
				clonedItems.push(...this.items)

				if (this.organizationFilter !== 'همه')
					clonedItems = clonedItems.filter(x => x.organizationIdId === this.organizationFilter)

				return clonedItems
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			manageLoans(item) {
				this.selectedMember = { id: item.memberId, fullName: item.memberFullName, nationalCode: item.memberNationalCode, mobile: item.memberMobile, userName: item.memberUserName }
				this.dialogLoansManager = true
			},
			loadData() {
				this.loading = true
				api.get('admin/report/OrganizationDueDated/?start=' + this.dateRange.start + '&end=' + this.dateRange.end + '&isCheckout=' + this.filterOnlyCheckout, {})
					.then(
						response => {
							this.items = response
							this.organizations = Object.values(
								response.reduce((acc, obj) => ({ ...acc, [obj.organizationId]: { id: obj.organizationId, title: obj.organizationName } }), {})
							)
							if (this.organizations.length) {
								this.organizations.push({ id: 'همه', title: 'همه' })
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			convertAssuranceType(type) {
				switch (type) {
					case 0:
						return 'سایر'
					case 1:
						return 'سازمان خود شخص'
					case 2:
						return 'سازمانی دیگران'
					case 3:
						return 'چک'
					case 4:
						return 'طلا'
				}
			}
		},
	}
</script>
<style></style>
